export default __webpack_public_path__ + "static/media/discord.1e2532d4.png";